import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getCareer, getVacancies, getVacancy } from 'api/Career';
import { fetchWithLanguage } from 'store/helpers';

export const fetchCareer = fetchWithLanguage('fetchCareer', getCareer);
export const fetchVacancies = fetchWithLanguage('fetchVacancies', getVacancies);
export const fetchVacancy = fetchWithLanguage('fetchVacancy', getVacancy);

const careerSlice = createSlice({
    name: 'careerSlice',
    initialState: {
        career: {},
        vacanciesList: {
            data: [],
            next: false,
        },
        vacancyContent: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchVacancies.fulfilled, (state, action) => {
                const { payload, meta } = action;
                state.vacanciesList.next = payload.next;

                if (meta.arg.page === 1) {
                    state.vacanciesList.data = payload.data;
                } else {
                    state.vacanciesList.data.push(...payload.data);
                }
            })
            .addCase(fetchCareer.fulfilled, (state, action) => {
                state.career = action.payload;
            })
            .addCase(fetchVacancy.fulfilled, (state, action) => {
                state.vacancyContent = action.payload;
            });
    },
});

export const selectCareerPage = createSelector([state => state.careerState.career], career => career.data || {});
export const selectVacanciesList = createSelector(
    [state => state.careerState.vacanciesList],
    vacanciesList => vacanciesList || {},
);
export const selectVacanciesContent = createSelector(
    [state => state.careerState.vacancyContent],
    vacancyContent => vacancyContent.data || {},
);

export default careerSlice.reducer;
